'use strict';

//這個由B設定, F使用
//v1/StatusCode 會產生下面的資訊, F 再copy paste 過來使用
//動態產生會有問題1. 開發期間沒辦法用IDE 幫忙, 2. 除非用async/await, always 還是會有call back 問題
export const StatusCode = {
    "OK": 200,
    "Save_Form_Data_Fail": 301,
    "Update_Form_Data_Fail": 302,
    "Delete_Form_Data_Fail": 303,
    "Session_Invalid": 401,
    "API_Access_Denied": 402,
    "Login_Fail": 403,
    "ExcelTemplate_Fail": 404,
    "ExcelTemplate_Columns_Should_be_Array_Fail": 405,
    "Upload_File_Fail": 406,
    "Change_Password_Request_Data_Empty": 407,
    "Reset_Password_Data_Empty": 408,
    "Reset_Password_Fail": 409,
    "Reset_Password_Fail_Cant_Find_Email": 410,
    "EmailTemplate_Fail": 411,
    "EmailNotification_Data_Empty": 412,
    "EmailNotification_Sent_Fail": 413,
    "Update_SEQ_Fail": 414,
    "Update_SEQ_Empty": 415,
    "Update_Columns_Fail": 416,
    "Validation_Wizard": 500,
    "Validation_KeyWord_Fail": 501,
    "Validation_Account_Password_Fail": 502,
    "Data_Exist": 601,
    "Data_Not_Exist": 602,
    "Data_Not_Match": 603,
    "Verify_Fail": 604,
    "Application_Exist": 605,
    "Link_Exist": 606,
    "ReCAPTCHA_Fail": 607,
    "File_Not_Exist": 608,
    "Sub_Node_Exist": 609,
    "Data_Be_Used": 610,
    "Account_Exist": 666,
    "PassWord_Empty": 667
};

export const RentStatusCode = {
    "OK": 200,
    "Save_Form_Data_Fail": 301,
    "Update_Form_Data_Fail": 302,
    "Delete_Form_Data_Fail": 303,
    "Session_Invalid": 401,
    "API_Access_Denied": 402,
    "Login_Fail": 403,
    "ExcelTemplate_Fail": 404,
    "ExcelTemplate_Columns_Should_be_Array_Fail": 405,
    "Upload_File_Fail": 406,
    "Change_Password_Request_Data_Empty": 407,
    "Reset_Password_Data_Empty": 408,
    "Reset_Password_Fail": 409,
    "Reset_Password_Fail_Cant_Find_Email": 410,
    "EmailTemplate_Fail": 411,
    "EmailNotification_Data_Empty": 412,
    "EmailNotification_Sent_Fail": 413,
    "Update_SEQ_Fail": 414,
    "Update_SEQ_Empty": 415,
    "Update_Columns_Fail": 416,
    "Validation_Wizard": 500,
    "Validation_KeyWord_Fail": 501,
    "Validation_Account_Password_Fail": 502,
    "Data_Exist": 631,
    "Data_Not_Exist": 632,
    "Data_Not_Match": 633,
    "Account_Not_Active": 634,
    "Data_Is_Limit": 635,
    "Not_Active": 636,
    "Over_Limit": 637,
    "ReCAPTCHA_Fail": 638,
    "No_Cancel": 639,
    "Data_Be_Used": 640,
    "Minutes_Later": 641,
    "Account_Exist": 666,
    "PassWord_Empty": 667
};
// i18n
export const ColumnName = {
  setting: {
    sDate: { CH: '開始時間' },
    sTime: { CH: '開始時間' },
    eDate: { CH: '結束時間' },
    eTime: { CH: '結束時間' },
    isActive: { CH: '停用彈跳視窗' },
    context: { CH: '內容設定' },
    homeInfo: { CH: '頁尾文字'}
  },
  link: {
    pictureUrl: { CH: '預覽圖' },
    nameCh: { CH: '名稱' },
    nameEn: { CH: '英文名稱' },
    isActive: { CH: '狀態' },
    updatedAt: { CH: '最後修改' },
    updatedByName: { CH: '操作人員' },
    linkUrl: { CH: '連結' }
  },
  webpage: {
    title: { CH: '網頁標題' },
    menuTitleCh: { CH: '對應列表' },
    language: { CH: '語系' },
    updatedAt: { CH: '最後修改' },
    updatedByName: { CH: '操作人員' },
    menuId: { CH: '選單功能對應' },
    linkUrl: { CH: '網址' },
    context: { CH: '段落' },
  },
  notice: {
    title: { CH: '標題' },
    typeNameCh: { CH: '類別' },
    typeNameEn: { CH: '類別(英文)' },
    isActive: { CH: '狀態' },
    updatedAt: { CH: '最後修改' },
    updatedByName: { CH: '操作人員' },
    language: { CH: '語系' },
    typeId: { CH: '類別' },
    sDate: { CH: '發佈時間' },
    sTime: { CH: '發佈時間' },
    eDate: { CH: '發佈時間' },
    eTime: { CH: '發佈時間' },
    linkType: { CH: '內容連結方式' },
    keepTop: { CH: '置頂' },
    sDateTop: { CH: '置頂時間' },
    sTimeTop: { CH: '置頂時間' },
    eDateTop: { CH: '置頂時間' },
    eTimeTop: { CH: '置頂時間' },
    context: { CH: '自訂內文' },
    files: { CH: '附加檔案' },
    pictures: { CH: '附加相片' },
    externalLink: { CH: '連結' },
    openMode: { CH: '開啟方式' },
  },
  site: {
    nameCh: { CH: '場地名稱' },
    nameEn: { CH: '英文場地名稱' },
    floor: { CH: '樓層' },
    updatedAt: { CH: '最後修改' },
    updatedByName: { CH: '最後修改人員' },
    introductionCh: { CH: '中文介紹' },
    introductionEn: { CH: '英文介紹' },
    pictures: { CH: '圖片' },
  },
  course: {
    schoolYear: { CH: '學年度' },
    nameCh: { CH: '課程名稱' },
    nameEn: { CH: '課程英文名稱' },
    updatedAt: { CH: '最後修改' },
    updatedByName: { CH: '操作人員' },
    isActive: { CH: '顯示狀態' },
    pictureUrl: { CH: '圖片' },
  },
  class: {
    courseNameCh: { CH: '課程名稱' },
    nameCh: { CH: '中文名稱' },
    nameEn: { CH: '英文名稱' },
    updatedAt: { CH: '最後修改' },
    updatedByName: { CH: '最後修改人員' },
    introductionCh: { CH: '中文介紹' },
    introductionEn: { CH: '英文介紹' },
    coachCh: { CH: '教練中文' },
    coachEn: { CH: '教練英文' },
    noteCh: { CH: '中文注意事項' },
    noteEn: { CH: '英文注意事項' },
    sDate: { CH: '開始日期' },
    eDate: { CH: '結束日期' },
  },
  classbatch: {
    classId: { CH: '班別' },
    week: { CH: '每週' },
    sDate: { CH: '開始日期' },
    eDate: { CH: '結束日期' },
  },
  classAdmissions: {
    classLevel: { CH: '課程分級' },
    memberType: { CH: '授課對象' },
    minMember: { CH: '團體班開課人數' },
    maxMember: { CH: '團體班額滿人數' },
    classHour: { CH: '上課時數' },
    classSite: { CH: '上課地點' },
    charges1: { CH: '校內身分收費' },
    charges2: { CH: '校外身分收費' },
    memo: { CH: '備註' },
    type: { CH: '類型' },
    maxPersonal: { CH: '個人班授課人數' },
  },
  admin: {
    account: { CH: '帳號' },
    email: { CH: 'email' },
    tel: { CH: '電話' },
    mobile: { CH: '手機' },
    businessCh: { CH: '負責業務' },
    businessEn: { CH: '負責業務英文' },
    agent: { CH: '代理人' },
    introductionCh: { CH: '中文介紹' },
    introductionEn: { CH: '英文介紹' },
    role: { CH: '權限設定' },
    jobTitleCh: { CH: '職稱' },
    jobTitleEn: { CH: '英文職稱' },
    nameCh: { CH: '姓名' },
    nameEn: { CH: '英文姓名' },
    isDisplay: { CH: '前台顯示狀態' },
    updatedAt: { CH: '最後修改' },
    updatedByName: { CH: '操作人員' }
  },
  teacher: {
    isDisplay: { CH: '前台' },
    nameCh: { CH: '中文姓名' },
    nameEn: { CH: '英文姓名' },
    title: { CH: '職稱' },
    updatedAt: { CH: '最後修改' },
    updatedByName: { CH: '操作人員' },
    account: { CH: '帳號' },
    email: { CH: 'email' },
    tel: { CH: '電話' },
    mobile: { CH: '手機' },
    dept: { CH: '行政職務 ' },
    office: { CH: '辦公室位置' },
    advisory: { CH: '諮詢時段' },
    website: { CH: '個人網頁' },
    subTitle: { CH: '其他職稱' },
    researchArea: { CH: '研究領域' },
    researchSummaryCh: { CH: '研究領域摘要中文' },
    researchSummaryEn: { CH: '研究領域摘要英文' },
    background: { CH: '學歷' },
    course: { CH: '課程' },
    honorCh: { CH: '獲獎中文' },
    honorEn: { CH: '獲獎英文' },
    historyCh: { CH: '經歷中文' },
    historyEn: { CH: '經歷英文' },
    agentName: { CH: '代理人姓名' },
    agentPassword: { CH: '代理人密碼' },
    agentEmail: { CH: '代理人email' },
    agentTel: { CH: '代理人電話' },
    agentActive: { CH: '代理人狀態' },
  },

  teacherpublication1: {
    title: { CH: '論文標題' },
    author: { CH: '作者 (群)' },
    nameCh: { CH: '名稱' },
    nameEn: { CH: '英文名稱' },
    place: { CH: '會議地點' },
    area: { CH: '出版領域' },
    pageSE: { CH: '刊載頁範圍' },
    publicationAt: { CH: '刊載日期' },
    memo: { CH: '備註' },
    pageS: { CH: '刊載頁範圍' },
    pageE: { CH: '刊載頁範圍' },
    context: { CH: '前台顯示文獻內容' },
  },    
  teacherpublication2: {
    title: { CH: '論文標題' },
    author: { CH: '作者 (群)' },
    nameCh: { CH: '名稱' },
    nameEn: { CH: '英文名稱' },
    journal: { CH: '刊載期號' },
    pageSE: { CH: '刊載頁範圍' },
    publicationAt: { CH: '刊載日期' },
    memo: { CH: '備註' },
    journalUnit: { CH: '刊載期號' },
    pageS: { CH: '刊載頁範圍' },
    pageE: { CH: '刊載頁範圍' },
    context: { CH: '前台顯示文獻內容' },
  },
  teacherpublication3: {
    title: { CH: '書名' },
    author: { CH: '作者 (群)' },
    nameCh: { CH: '出版社' },
    nameEn: { CH: '出版社(英文)' },
    reviewSystem: { CH: '審查制度' },
    isbn: { CH: 'ISBN' },
    publicationCountry: { CH: '出版國' },
    publicationPages: { CH: '頁數' },
    publicationAt: { CH: '出版年份' },
    memo: { CH: '備註' },
    isbn13: { CH: 'isbn13' },
    isbn10: { CH: 'isbn10' },
    context: { CH: '前台顯示文獻內容' },
  },
  teacherpublication4: {
    nameCh: { CH: '計畫名稱 (中文)' },
    nameEn: { CH: '計畫名稱 (英文)' },
    fundSourceCh: { CH: '經費來源 (中文)' },
    fundSourceEn: { CH: '經費來源 (英文)' },
    planNo: { CH: '計畫編號' },
    fundBudget: { CH: '經費預算' },
    executiveDateSE: { CH: '執行期間' },
    memo: { CH: '備註' },
    executiveDateS: { CH: '執行期間' },
    executiveDateE: { CH: '執行期間' },
    context: { CH: '前台顯示文獻內容' },
  },
  teachercustom: {
    nameCh: { CH: '計畫名稱 (中文)' },
    nameEn: { CH: '計畫名稱 (英文)' },
    contextCh: { CH: '中文內文' },
    contextEn: { CH: '英文內文' },
  },
  team: {
    nameCh: { CH: '體育代表隊名稱' },
    nameEn: { CH: '英文名稱' },
    type: { CH: '種類' },
    updatedAt: { CH: '最後修改' },
    updatedByName: { CH: '操作人員' },
  },
  message: {
    guestName: { CH: '留言者' },
    guestMessage: { CH: '留言內容' },
    isDisplay: { CH: '發佈狀態' },
    updatedAt: { CH: '最後修改' },
    updatedByName: { CH: '最後修改人員' },
    guestEmail: { CH: '留言者信箱' },
    reply: { CH: '回覆' },
  },
  journal: {
    title: { CH: '名稱' },
    typeNameCh: { CH: '類別' },
    typeNameEn: { CH: '類別' },
    updatedAt: { CH: '最後修改' },
    updatedByName: { CH: '操作人員' }
  },
  filemanager: {
    title: { CH: '名稱' },
    typeNameCh: { CH: '類別' },
    typeNameEn: { CH: '類別(英文)' },
    updatedAt: { CH: '最後修改' },
    updatedByName: { CH: '操作人員' }
  },
  code: {
    nameCh: { CH: '類別名稱' },
    nameEn: { CH: '類別名稱(英文)' },
    updatedAt: { CH: '最後修改' },
    updatedByName: { CH: '操作人員' }
  },
  application: {
    courseNameCh: { CH: '課程名稱' },
    classNameCh: { CH: '班別' },
    name: { CH: '姓名' },
    sex: { CH: '性別' },
    email: { CH: 'email' },
    mobile: { CH: '手機' },
    birthday: { CH: '生日' },
    coachName: { CH: '教練需求' },
    status: { CH: '處理狀態' },
    updatedAt: { CH: '最後修改' },
    updatedByName: { CH: '操作人員' },
    idNo: { CH: '身份證號' },
    serviceUnit: { CH: '服務單位' },
    parentsName: { CH: '家長姓名' },
    tel: { CH: '電話' },
    address: { CH: '地址' },
    memberType: { CH: '班別' },
    chargesType: { CH: '收費標準' },
    classWeek: { CH: '上課週' },
    classCount: { CH: '希望堂數' },
    classTime: { CH: '上課時段' },
    classTimeOther: { CH: '其他時段' },
    coach: { CH: '指定教練' },
    coachOther: { CH: '指定教練姓名' },
  },
  menu: {
    preMenuId: { CH: '上層' },
    titleCh: { CH: '中文標題' },
    titleEn: { CH: '英文標題' },
    kind: { CH: '選單種類' },
    display: { CH: '顯示控制' },
    immediate: { CH: '直接上架' },
    keep: { CH: '永不下架' },
    sDate: { CH: '開始日期' },
    eDate: { CH: '結束日期' },
    rejectSearch: { CH: '拒絕google搜尋' },
    linkUrl: { CH: '連結路徑' },
    openMode: { CH: '開啟方式' },
    funId: { CH: '系統功能' },
  },
  album: {
    nameCh: { CH: '名稱' },
    nameEn: { CH: '英文名稱' },
    memoCh: { CH: '中文備註' },
    memoEn: { CH: '英文備註' },
    type: { CH: '種類' },
    teamId: { CH: '對應到的代表隊' },
    coverPictureUrl: { CH: '封面圖檔路徑' },
  },
  picture: {
    memo: { CH: '備註' },
  },
  video: {
    titleCh: { CH: '中文標題' },
    titleEn: { CH: '英文標題' },
    coverPictureUrl: { CH: '封面圖檔路徑' }, 
    isActive: { CH: '狀態' },
  },
  columns: {
    columns: { CH: '欄位' },
  },


  yearoption: {
    rocYear: { CH: '學年度' },
    beginTime: { CH: '開放時間' },
    endTime: { CH: '結束時間' },
    updatedAt: { CH: '最後修改' },
    updatedByName: { CH: '操作人員' }
  },
  yearuser: {
    rocYear: { CH: '申請年度' },
    unitName: { CH: '申請系所' },
    unitType: { CH: '申請系所種類' },
    teamType: { CH: '申請類別' },
    status: { CH: '狀態' },
    account: { CH: '帳號' },
    updatedAt: { CH: '最後修改' },
    updatedByName: { CH: '操作人員' },
  },
  periodoption: {
    timePeriod: { CH: '學年度' },
    updatedAt: { CH: '最後修改' },
    updatedByName: { CH: '操作人員' }
  },
  yearuserapply: {
    rocYear: { CH: '學年度' },
    unitName: { CH: '學年度' },
    unitType: { CH: '學年度' },
    teamType: { CH: '學年度' },
    status: { CH: '學年度' },
    account: { CH: '學年度' },
    updatedAt: { CH: '最後修改' },
    updatedByName: { CH: '操作人員' }
  },
  yearuserrent: {
    unitName: { CH: '系所' },
    unitType: { CH: '系所種類' },
    teamType: { CH: '類別' },
    account: { CH: '帳號' },
    buildingName: { CH: '預約建物' },
    venueName: { CH: '預約場地' },
    rentDate: { CH: '預約日期' },
    rentTimePeriod: { CH: '預約時段' },
    confirmDeadLine: { CH: '取消期限' },
    createdAt: { CH: '創建時間' },
    statusConfirm: { CH: '確認狀態' },
    statusRent: { CH: '狀態' },
    updatedAt: { CH: '最後修改' },
    updatedByName: { CH: '操作人員' }
  },
  yearuserrent2: {
    unitName: { CH: '系所' },
    unitType: { CH: '系所種類' },
    teamType: { CH: '類別' },
    account: { CH: '帳號' },
    buildingName: { CH: '預約建物' },
    venueName: { CH: '預約場地' },
    rentDate: { CH: '預約日期' },
    rentTimePeriod: { CH: '預約時段' },
    confirmDeadLine: { CH: '取消期限2' },
    createdAt: { CH: '創建時間' },
    statusConfirm: { CH: '確認狀態' },
    statusRent: { CH: '狀態' },
    updatedAt: { CH: '最後修改' },
    updatedByName: { CH: '操作人員' }
  },
  yearuserrent3: {
    unitName: { CH: '系所' },
    unitType: { CH: '系所種類' },
    teamType: { CH: '類別' },
    account: { CH: '帳號' },
    buildingName: { CH: '預約建物' },
    venueName: { CH: '預約場地' },
    rentDate: { CH: '預約日期' },
    rentTimePeriod: { CH: '預約時段' },
    confirmDeadLine: { CH: '取消期限3' },
    createdAt: { CH: '創建時間' },
    statusConfirm: { CH: '確認狀態' },
    statusRent: { CH: '狀態' },
    updatedAt: { CH: '最後修改' },
    updatedByName: { CH: '操作人員' }
  },
  building: {
    buildingName: { CH: '名稱' },
    updatedAt: { CH: '最後修改' },
    updatedByName: { CH: '操作人員' }
  },
  venue: {
    buildingName: { CH: '建物名稱' },
    venueName: { CH: '名稱' },
    updatedAt: { CH: '最後修改' },
    updatedByName: { CH: '操作人員' }
  },
  activityused: {
    activityName: { CH: '活動名稱' },
    unitName: { CH: '主辦單位' },
    beginDate: { CH: '活動開始日期' },
    endDate: { CH: '活動結束日期' },
    timePeriod: { CH: '活動時段' },
    activityWeek: { CH: '活動時段(週)' },
    buildingVenueName: { CH: '活動地點' },
    updatedAt: { CH: '最後修改' },
    updatedByName: { CH: '操作人員' }
  },
  yearuserblacklist: {
    rocYear: { CH: '學年度' },
    month: { CH: '月份' },
    account: { CH: '帳號' },
    unitName: { CH: '系所名稱' },
    unitType: { CH: '系所種類' },
    teamType: { CH: '類別' },
    updatedAt: { CH: '最後修改' },
    updatedByName: { CH: '操作人員' }
  },
  schedulesetting: {
    registerStartD: { CH: '開放抽籤登記時間 日' },
    registerStartH: { CH: '開放抽籤登記時間 時' },
    registerStartM: { CH: '開放抽籤登記時間 分' },
    registerEndD: { CH: '結束抽籤登記時間 日' },
    registerEndH: { CH: '結束抽籤登記時間 時' },
    registerEndM: { CH: '結束抽籤登記時間 分' },
    postResultD: { CH: '公告抽籤結果時間 日' },
    postResultH: { CH: '公告抽籤結果時間 時' },
    postResultM: { CH: '公告抽籤結果時間 分' },
    rentStartD: { CH: '開放手動租借時間 日' },
    rentStartH: { CH: '開放手動租借時間 時' },
    rentStartM: { CH: '開放手動租借時間 分' },
    undergraduate_register_limi: { CH: '大學部系隊登記時段數量' },
    graduate_register_limit: { CH: '研究所系隊登記時段數量' },
    groupRegisterLimit: { CH: '社團系隊登記時段數量' },
    drawnMailContent: { CH: '中籤通知 mail 設定' },
  },
};

export const Message = {
    AccountPassword: {EN: "Please input account / password", CH: "請輸入帳號密碼"},
    AccountPasswordError: {EN: "Account/Password can't be empty", CH: "帳號密碼錯誤"},
    AccountExist: {EN: "Account exist", CH: "帳號已存在"},
    
    Add: {EN: "Add", CH: "新增"},
    Delete: {EN: "Delete", CH: "刪除"},
    Edit: {EN: "Edit", CH: "編輯"},
    Save: {EN: "Save", CH: "儲存"},
    Back: {EN: "Back", CH: "回上一頁"},
    SaveSuccessfully: {EN: "Save Successfully", CH: "儲存成功"},
    SaveFail: {EN: "Save Fail", CH: "儲存失敗"},

    DeleteSuccessfully: {EN: "Delete Successfully", CH: "刪除成功"},
    DeleteFail: {EN: "Delete Fail", CH: "刪除失敗"},
    DeleteConfirm: {EN: "Please confirm you want to delete the record(s).", CH: "確認是否刪除?"},

    SearchKeyword: {EN: "Search key word", CH: "搜尋關鍵字"},
    IsInvalid: {EN: " is invalid", CH: "欄位無效"},
    CanNotBeEmpty: {EN: " can't be empty", CH: "不能為空"},
    PaginationLeft: {CH: "每頁顯示", EN: "Records per page"},
    PaginationRight: {CH: "筆", EN: ""},

    NoAuth: {CH: "沒有授權! Token 可能已失效, 請重新登入", EN: "Access Denied! Token may has been expired, please login again."},

    NoQueryData: {CH: "查無資料。", EN: ""},

    API_Access_Denied: {CH: "沒有授權! Token 可能已失效, 請重新登入", EN: "Access Denied! Token may has been expired, please login again."},
    Update_Form_Data_Fail: {EN: "Save Fail", CH: "儲存失敗"},
    Not_Started: {EN: "Not Start", CH: "尚未啟用"},
    Expired: {EN: "Expired", CH: "超過期限"},
    OK: {EN: "OK", CH: "OK"},
    Save_Form_Data_Fail: {EN: "Save_Form_Data_Fail", CH: "儲存失敗"},
    Delete_Form_Data_Fail: {EN: "Delete_Form_Data_Fail", CH: "刪除失敗"},
    Session_Invalid: {EN: "Session_Invalid", CH: "Session無效"},
    Login_Fail: {EN: "Login_Fail", CH: "登入失敗"},
    ExcelTemplate_Fail: {EN: "ExcelTemplate_Fail", CH: "ExcelTemplate_Fail"},
    ExcelTemplate_Columns_Should_be_Array_Fail: {EN: "ExcelTemplate_Columns_Should_be_Array_Fail", CH: "ExcelTemplate_Columns_Should_be_Array_Fail"},
    Upload_File_Fail: {EN: "Upload_File_Fail", CH: "上傳檔案失敗"},
    Change_Password_Request_Data_Empty: {EN: "Change_Password_Request_Data_Empty", CH: "改變密碼資料為空"},
    Reset_Password_Data_Empty: {EN: "Reset_Password_Data_Empty", CH: "空密碼錯誤"},
    Reset_Password_Fail: {EN: "Reset_Password_Fail", CH: "變更密碼失敗"},
    Reset_Password_Fail_Cant_Find_Email: {EN: "Reset_Password_Fail_Cant_Find_Email", CH: "變更密碼失敗，沒有此信箱"},
    EmailTemplate_Fail: {EN: "EmailTemplate_Fail", CH: ""},
    EmailNotification_Data_Empty: {EN: "EmailNotification_Data_Empty", CH: ""},
    EmailNotification_Sent_Fail: {EN: "EmailNotification_Sent_Fail", CH: ""},
    Update_SEQ_Fail: {EN: "Update_SEQ_Fail", CH: ""},
    Update_SEQ_Empty: {EN: "Update_SEQ_Empty", CH: ""},
    Update_Columns_Fail: {EN: "Update_Columns_Fail", CH: "更新欄位失敗"},
    Validation_Wizard: {EN: "Validation_Wizard", CH: "認證無效"},
    Validation_KeyWord_Fail: {EN: "Validation_KeyWord_Fail", CH: "認證碼錯誤"},
    Validation_Account_Password_Fail: {EN: "Validation_Account_Password_Fail", CH: "帳號密碼錯誤"},
    Data_Exist: {EN: "Data_Exist", CH: "資料已存在"},
    Data_Not_Exist: {EN: "Data_Not_Exist", CH: "資料不存在"},
    Data_Not_Match: {EN: "Data_Not_Match", CH: "資料不符合"},
    Verify_Fail: {EN: "Verify_Fail", CH: "認證失敗"},
    Application_Exist: {EN: "Application_Exist", CH: "報名存在"},
    Link_Exist: {EN: "Link_Exist", CH: "連結存在"},
    ReCAPTCHA_Fail: {EN: "ReCAPTCHA_Fail", CH: ""},
    File_Not_Exist: { EN: "File_Not_Exist", CH: "檔案不存在" },
    Sub_Node_Exist: { EN: "Sub_Node_Exist", CH: "" },
    Data_Be_Used: { EN: "Data_Be_Used", CH: "資料已被使用，不允許刪除" },
    Account_Exist: {EN: "Account_Exist", CH: "帳號存在"},
    PassWord_Empty: {EN: "PassWord_Empty", CH: "密碼為空"},

    Data_Is_Limit: {EN: "Data_Is_Limit", CH: "非限制的場地"},
    Account_Not_Active: {EN: "Account_Not_Active", CH: "帳號未啟動"},
    Not_Active: { EN: "Not_Active", CH: "活動未開始"},
    Over_Limit: { EN: "Over_Limit", CH: "超過限制" },
    No_Cancel: { EN: "No_Cancel", CH: "該資料非取消。" },
    Over_Limit: { EN: "Over_Limit", CH: "超過限制。" },
    Minutes_Later: { EN: "Minutes_Later", CH: "抽籤期間，不能預約。" },
};

export function PostErrorHandler(error, api) {
  console.log(error)

  let NowStatusCode = api.indexOf('rent_') !== -1 ? RentStatusCode : StatusCode;

    let statusCode = parseInt(error.response.data.statusCode);
    if (statusCode === NowStatusCode.Session_Invalid) {
      let that = this;
      while(that.login_modal !== false) {
        that = that.$parent;
      }
      that.login_modal = true;
    }
    else if(error.response.status === 401) {    
      let that = this;
      while(that.login_modal !== false) {
        that = that.$parent;
      }
      that.login_modal = true;
    }

    else if (statusCode === NowStatusCode.Validation_Wizard) {
        let a = '';
        for (var property in error.response.data) {
            if (property !== 'statusCode') {
                if (error.response.data.hasOwnProperty(property)) {
                    var res = error.response.data[property].split("_");
                    if (res.length === 2) {
                        a += getColumnName(api, res[0]);
                        // a += ColumnName[api][res[0]] === undefined ? res[0] : ColumnName[api][res[0]][sessionStorage.locale];
                        a += Message[res[1]] === undefined ? res[1] : Message[res[1]][sessionStorage.locale] + "\r\n";
                    }
                }
            }
        }
        ShowMessage(a);
    }
    else {
      for (let props in NowStatusCode) {
        if (statusCode === NowStatusCode[props]) {
          ShowMessage(Message[props][sessionStorage.locale]);
        }
      }
    }
}

export function DeleteErrorHandler(error) {
    // console.log(error)
    let statusCode = parseInt(error.response.data.statusCode);
    if (statusCode === StatusCode.API_Access_Denied) {
        ShowMessage(Message.NoAuth[sessionStorage.locale]);
        this.$router.push('/login');
    }
    else {
      for (let props in RentStatusCode) {
        if (statusCode === RentStatusCode[props]) {
          ShowMessage(Message[props][sessionStorage.locale]);
        }
      }
    }
    
    
}

export function GetErrorHandler(error) {  
  console.log(error)
    let statusCode = parseInt(error.response.data.statusCode);
    if (statusCode === StatusCode.Session_Invalid) {
        this.$router.push('/login');;
    }
    else {
      for (let props in StatusCode) {
        if (statusCode === StatusCode[props]) {
          ShowMessage(Message[props][sessionStorage.locale]);
        }
      }
    }
    
}

export function ShowMessage(msg) {
    alert(msg);
}

export function getColumnName(api, key) {
    var colName = "NA";
    if (api.indexOf('rent_') !== -1)
        api = api.replace('rent_', '');

    if (ColumnName[api] !== undefined && ColumnName[api][key] !== undefined) {
        return ColumnName[api][key][sessionStorage.locale];
    } else if (ColumnName["Common"][key] !== undefined) {
        return ColumnName["Common"][key][sessionStorage.locale];
    }

    return colName;
}



// WEBPACK FOOTER //
// ./src/assets/library/axiosErrorHandler.js